<template>
  <div class="w-100">
    <z-form-group class="row">
      <div class="col-4 text-right">
        {{ $t(`pbx.worksheet.action.entry.input.record.label`) }}
      </div>
      <div class="col-sm-8 d-flex">
        <template v-if="is_have_permission">
          <z-switch v-model="form.is_enable" />
        </template>
        <template v-if="!is_have_permission">
          <tooltip :transfer="true" theme="light" max-width="200" class="d-flex">
            <z-switch :value="false" :disabled="true" />
            <div
              slot="content"
              class="text-left"
              v-html="$t('pbx.service-package.limit.record')"
            ></div>
          </tooltip>
          <router-link
            :to="{ name: 'pbx.service-package.index' }"
            class="col-10 d-flex align-items-center"
          >
            <span @click="$emit('closeModal')">{{
              $t('pbx.worksheet.action.entry.input.links.label')
            }}</span>
          </router-link>
        </template>
      </div>
    </z-form-group>

    <z-form-group class="row">
      <div class="col-4 text-right">
        {{ $t(`pbx.worksheet.action.entry.input.calls_only.label`) }}
      </div>

      <div class="col-sm-8 d-flex">
        <tooltip
          :transfer="true"
          theme="light"
          :max-width="is_have_permission ? 300 : 200"
          class="d-flex"
        >
          <z-switch
            v-model="form.calls_only"
            size="large"
            :disabled="!form.is_enable || !is_have_permission"
          />
          <div
            slot="content"
            class="text-left"
            v-html="
              is_have_permission
                ? $t('pbx.worksheet.action.entry.input.calls_only.description')
                : $t('pbx.service-package.limit.record')
            "
          ></div>
        </tooltip>
        <router-link
          v-if="!is_have_permission"
          :to="{ name: 'pbx.service-package.index' }"
          class="col-10 d-flex align-items-center"
        >
          <span @click="$emit('closeModal')">{{
            $t('pbx.worksheet.action.entry.input.links.label')
          }}</span>
        </router-link>
      </div>
    </z-form-group>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        default: 'no'
      }
    },

    data() {
      return {
        form: {
          is_enable: false,
          calls_only: false
        }
      };
    },

    computed: {
      is_have_permission: function () {
        try {
          return this.$user.pbx.is_allow_record;
        } catch (e) {
          console.error('Не могу получить информаицю о пакте');
        }
        return false;
      }
    },

    watch: {
      value: {
        handler: function (type) {
          if (this.is_have_permission) {
            if (type === 'no') {
              this.form.is_enable = false;
              this.form.calls_only = false;
            }

            if (type === 'all') {
              this.form.is_enable = true;
              this.form.calls_only = false;
            }

            if (type === 'calls_only') {
              this.form.is_enable = true;
              this.form.calls_only = true;
            }
          } else {
            this.$emit('input', 'no');
          }
        },
        immediate: true
      },

      form: {
        handler: function (w) {
          const current_value = this.value;
          let new_value = 'no';

          if (w.is_enable) {
            new_value = w.calls_only ? 'calls_only' : 'all';
          }

          if (current_value !== new_value) {
            this.$emit('input', new_value);
          }
        },
        deep: true
      }
    }
  };
</script>
